// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"4baf394b","275":"dfc3c2c4","583":"766920ab","609":"2e1d27ee","787":"a54cc342"}[chunkId] + ".chunk.js";
};